import { apiCall } from ".";
import { LoanQueryParams } from "../interfaces";

export const fetchInvestmentsApi = (params: LoanQueryParams) => {
  return apiCall(true).get("/investments", { params });
};
